import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async getConversations () {
    return axios.get('/api/conversations').then(r => r.data)
      .catch(errorHandler)
  },
  async sendMessageToUser ({ content, userId }) {
    return axios.post('/api/messages', { content, to: userId })
      .then(r => r.data).catch(errorHandler)
  },
  async sendMessageToConversation ({ content, conversation }) {
    return axios.post(`/api/conversations/${conversation.id}`, { content })
      .then(r => r.data).catch(errorHandler)
  },
  async getConversation (id) {
    return axios.get(`/api/conversations/${id}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getMessagesForConversation (id) {
    return axios.get(`/api/conversations/${id}/messages`)
      .then(r => r.data).catch(errorHandler)
  },
  async getConversationWithUser (user) {
    return axios.get(`/api/conversations/user/${user.id}`)
      .then(r => r.data).catch(errorHandler)
  },
  async updateConversationStatus (conversationId, message) {
    return axios.put(`/api/conversations/${conversationId}/status`, {
      message: message.id
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/conversations.js